// Kennzahl-Kachel der Aktivitätsübersicht (R-02, R-06): große Zahl, Titel mit Auswahlpfeil, graue Zeile, Veränderung zum Vergleich,
// Sparkline. Das X (bei Hover oder Fokus) entfernt die Kachel; „Kachel hinzufügen“ ist gestrichelt.
import { useState } from "react";
import type { Kennzahl, KennzahlWert } from "../api/berichte";
import { Icon } from "../components/Icon";
import { veraenderungText, wertText } from "./format";
import { Sparkline } from "./Diagramme";
import { KennzahlWahl } from "./KennzahlWahl";
import { BT } from "./texte";

interface Props {
  kennzahl: Kennzahl;
  wert: KennzahlWert | undefined;
  katalog: Kennzahl[];
  verwendet: Set<string>;
  laedt: boolean;
  vergleich: boolean;
  onTauschen: (neu: string) => void;
  onEntfernen: () => void;
  /** Nutzer darf den Bericht umbauen (sonst nur ansehen, Änderungen gehen über „Speichern unter“) */
  bearbeitbar?: boolean;
}

export function Kachel({ kennzahl, wert, katalog, verwendet, laedt, vergleich, onTauschen, onEntfernen }: Props) {
  const [offen, setOffen] = useState(false);
  const [anker, setAnker] = useState<HTMLButtonElement | null>(null);
  const aenderung = wert?.veraenderung_prozent;
  const richtung = aenderung === null || aenderung === undefined ? "" : aenderung > 0 ? "hoch" : aenderung < 0 ? "runter" : "gleich";
  const reihe = wert?.reihe?.map((p) => p.wert) ?? [];
  return (
    <div className={`kachel${laedt ? " kachel--laedt" : ""}`}>
      <button type="button" className="kachel__x" aria-label={`Kachel „${kennzahl.titel}“ entfernen`} title="Kachel entfernen" onClick={onEntfernen}>
        <Icon name="schliessen" groesse={12} />
      </button>
      <div className="kachel__zahl" aria-live="polite">
        {wert ? wertText(wert.wert, kennzahl.einheit) : "–"}
      </div>
      {vergleich ? (
        <div className={`kachel__delta kachel__delta--${richtung}`} title={wert?.vergleich_wert !== undefined ? `Vergleich: ${wertText(wert?.vergleich_wert ?? null, kennzahl.einheit)}` : undefined}>
          {richtung === "hoch" ? "▲ " : richtung === "runter" ? "▼ " : ""}
          {aenderung === null || aenderung === undefined ? (wert?.vergleich_wert !== undefined ? `vorher ${wertText(wert.vergleich_wert, kennzahl.einheit)}` : "") : veraenderungText(aenderung)}
        </div>
      ) : null}
      <button ref={setAnker} type="button" className="kachel__titel" aria-haspopup="dialog" aria-expanded={offen} title={`${kennzahl.titel}${kennzahl.untertitel ? ` (${kennzahl.untertitel.toLocaleLowerCase("de")})` : ""}. Anklicken zum Wechseln.${kennzahl.beschreibung ? ` ${kennzahl.beschreibung}` : ""}`} onClick={() => setOffen((o) => !o)}>
        <span className="kachel__titeltext">{kennzahl.titel}</span>
        <Icon name="chevron-unten" groesse={12} />
      </button>
      <div className="kachel__unter" title={kennzahl.untertitel}>{kennzahl.untertitel}</div>
      <Sparkline werte={reihe} titel={`Verlauf ${kennzahl.titel}`} />
      <KennzahlWahl katalog={katalog} anker={anker} offen={offen} onSchliessen={() => setOffen(false)} ausgeschlossen={verwendet} aktuell={kennzahl.id} onWahl={onTauschen} />
    </div>
  );
}

export function KachelNeu({ katalog, verwendet, onWahl }: { katalog: Kennzahl[]; verwendet: Set<string>; onWahl: (id: string) => void }) {
  const [offen, setOffen] = useState(false);
  const [anker, setAnker] = useState<HTMLButtonElement | null>(null);
  return (
    <>
      <button ref={setAnker} type="button" className="kachel kachel--neu" aria-haspopup="dialog" aria-expanded={offen} onClick={() => setOffen((o) => !o)}>
        <Icon name="plus" groesse={14} />
        <span>{BT.kachelHinzu}</span>
      </button>
      <KennzahlWahl katalog={katalog} anker={anker} offen={offen} onSchliessen={() => setOffen(false)} ausgeschlossen={verwendet} onWahl={onWahl} />
    </>
  );
}
